import { ReactElement } from 'react';
import { SafetyAlertModel } from '@casops/store/apis/personnelSafetyApi';
import MapView from '@cas/components/maps/map-view/MapView';
import SingleAssetPositionLayer from '@casops/components/maps/single-asset-pos/SingleAssetPositionLayer';
import MapLoader from '@cas/components/maps/map-loader/MapLoader';
import { LayersControl, Pane } from 'react-leaflet';
import { useTranslation } from 'react-i18next';
import { SafetyEventLayer } from '@casops/components/maps/safety-alert-map/safety-event-layer/SafetyEventLayer';
import usePositionsOnMap from '@casops/components/maps/hooks/usePositionsOnMap';
import { LeafletPaneZIndex } from '@casops/components/maps/mapConfig';
import { NearbyAssetsGroup } from './nearby-assets-group/NearbyAssetsGroup';

// Draw the custom marker panes above all default panes
const ASSET_ZINDEX = LeafletPaneZIndex.popup + 1;
const EVENT_ZINDEX = ASSET_ZINDEX + 1;
// Draw both tooltip panes above the custom marker panes.
const ASSET_TOOLTIP_ZINDEX = EVENT_ZINDEX + 1;
const EVENT_TOOLTIP_ZINDEX = ASSET_TOOLTIP_ZINDEX + 1;
const ASSET_PANE_NAME = 'asset';
const EVENT_PANE_NAME = 'event';
const ASSET_TOOLTIP_PANE_NAME = 'asset-tooltip';
const EVENT_TOOLTIP_PANE_NAME = 'event-tooltip';

interface SafetyAlertMapProps {
  item?: SafetyAlertModel;
}

export const SafetyAlertMap = ({ item }: SafetyAlertMapProps): ReactElement => {
  const { t } = useTranslation();

  const mapProps = usePositionsOnMap(item ? [item.posA] : []);

  const hasNearbyAssets = !!item?.nby.length;

  return (
    <MapLoader showMap={!!item} isFetching={!item}>
      <MapView {...mapProps} padding initialZoom={18} showLayersControl={hasNearbyAssets}>
        {hasNearbyAssets && (
          <LayersControl.Overlay name={t('Model.Plural.Asset_other')} checked={true}>
            <NearbyAssetsGroup assets={item.nby} />
          </LayersControl.Overlay>
        )}
        <Pane name={ASSET_PANE_NAME} style={{ zIndex: ASSET_ZINDEX }}>
          {item?.posG && (
            <SingleAssetPositionLayer
              posG={item.posG}
              customLabel={`${t('Fields.PPUID')} ${item.did}`}
              tooltipPane={ASSET_TOOLTIP_PANE_NAME}
            />
          )}
        </Pane>
        <Pane name={ASSET_TOOLTIP_PANE_NAME} style={{ zIndex: ASSET_TOOLTIP_ZINDEX }} />
        <Pane name={EVENT_PANE_NAME} style={{ zIndex: EVENT_ZINDEX }}>
          {item && <SafetyEventLayer alert={item} tooltipPane={EVENT_TOOLTIP_PANE_NAME} />}
        </Pane>
        <Pane name={EVENT_TOOLTIP_PANE_NAME} style={{ zIndex: EVENT_TOOLTIP_ZINDEX }} />
      </MapView>
    </MapLoader>
  );
};
